import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, FormControl, FormHelperText, Typography } from "@mui/material";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import SiderBorder from "../../../components/SiderBorder";
import PasswordBox from "../../../components/PasswordBox";
import BackLogin from "../../../components/BackLogin";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { passwordResetMail } from "./forgotData";
import { useLoading } from "../../../../context/LodingContext";
import PageLayout from "../../../../layoutcontainers/PageLayout";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import loginimage from "../../../assest/images/logipagebg1.png";
import logo from "../../../assest/images/meefoodlogo.png";
import { Email } from "@mui/icons-material";

const EmailForgotInput = () => {
  const [forgotState, setForgotState] = useState({
    email: "",
    emailStatus: "",
  });
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const value = e?.target.value;

    const alphaNLenghthRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (alphaNLenghthRegex.test(value)) {
      setForgotState({
        email: value,
        emailStatus: "success",
      });
    } else if (!value) {
      setForgotState({
        email: "",
        emailStatus: "unchecked",
      });
    } else {
      setForgotState({
        email: value,
        emailStatus: "error",
      });
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (forgotState.emailStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSumbit = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, passwordResetMail, {
        email: forgotState?.email,
      });

      const status = await res?.passwordResetMail?.success;
      const message = await res?.passwordResetMail?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "99999999999999";
          },
        }).then(() => {
          navigate("/sign-in");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "999999999999999";
          },
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const keydownHandler = (event) => {
    if (event.key === "Enter" && forgotState.emailStatus === "success") {
      handleSumbit();
    }
  };

  return (
    <PageLayout disableFooter showNavbar>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${loginimage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          padding: { xs: "20px 15px", md: "35px 20px 20px" },
          overflowY: "auto",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 1,
          },
        }}
      >
        {/* Glass Card */}
        <Box
          sx={{
            zIndex: 2,
            width: "100%",
            maxWidth: "420px",
            backgroundColor: "rgba(0, 0, 0, 0.42)",
            borderRadius: "6px",
            boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            padding: { xs: "30px 24px", sm: "40px 36px 32px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            my: "auto",
          }}
        >
          {/* Logo Circle */}
          <Box
            sx={{
              width: "78px",
              height: "78px",
              borderRadius: "50%",
              backgroundColor: "#ffffff",
              padding: "3px",
              border: "3px solid rgba(255, 255, 255, 0.8)",
              boxShadow: "0 4px 14px rgba(0,0,0,0.35)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              mb: 1.5,
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "contain",
              }}
            />
          </Box>

          {/* Title */}
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: "17px",
              fontWeight: 400,
              letterSpacing: "0.5px",
              mb: 3,
              textAlign: "center",
            }}
          >
            Forgot Password ?
            <br />
            <span style={{ fontSize: "13px", color: "rgba(255,255,255,0.75)" }}>
              Enter your email to reset your password.
            </span>
          </Typography>

          {/* Form */}
          <Box sx={{ width: "100%", maxWidth: "380px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>

              {/* Email Field */}
              <Box sx={{ position: "relative" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#ffffff",
                    borderRadius: "4px",
                    padding: "4px 12px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    border:
                      forgotState.emailStatus === "error"
                        ? "1px solid #d32f2f"
                        : "1px solid transparent",
                  }}
                >
                  <input
                    type="text"
                    name="email"
                    placeholder="Email"
                    value={forgotState.email}
                    onKeyDown={keydownHandler}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "14px",
                      color: "#333",
                      padding: "8px 0",
                      background: "transparent",
                    }}
                  />

                   <Email
                        sx={{
                          color: '#777',
                          fontSize: 20,
                          ml: 1
                        }}/>
                  
                </Box>
                {forgotState.emailStatus === "error" && (
                  <FormControl
                    sx={{ position: "absolute", bottom: "-20px", left: 0 }}
                    error
                  >
                    <FormHelperText
                      sx={{ color: "#ff8b8b !important", m: 0, fontSize: "11px" }}
                    >
                      Invalid email address
                    </FormHelperText>
                  </FormControl>
                )}
              </Box>

              {/* Back to Login */}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
                <Typography
                  onClick={() => navigate("/sign-in")}
                  sx={{
                    color: "rgba(255, 255, 255, 0.85)",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "color 0.2s",
                    "&:hover": {
                      color: "#ffffff",
                      textDecoration: "underline",
                    },
                  }}
                >
                  ← Back to Login
                </Typography>
              </Box>

              {/* Submit Button */}
              <Box sx={{ mt: 0.5 }}>
                <button
                  type="button"
                  onClick={handleSumbit}
                  disabled={!checkAllFields()}
                  style={{
                    width: "100%",
                    padding: "11px 0",
                    backgroundColor: checkAllFields() ? "#05a85c" : "#05a85ca6",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: 600,
                    letterSpacing: "1px",
                    cursor: checkAllFields() ? "pointer" : "not-allowed",
                    transition: "all 0.3s ease",
                    boxShadow: "0 3px 8px rgba(5, 168, 92, 0.4)",
                  }}
                  onMouseOver={(e) => {
                    if (checkAllFields())
                      e.currentTarget.style.backgroundColor = "#048c4d";
                  }}
                  onMouseOut={(e) => {
                    if (checkAllFields())
                      e.currentTarget.style.backgroundColor = "#05a85c";
                  }}
                >
                  SUBMIT
                </button>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            zIndex: 2,
            textAlign: "center",
            width: "100%",
            pb: 1,
            mt: 2,
          }}
        >
          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: { xs: "12px", sm: "13px" },
              letterSpacing: "0.5px",
            }}
          >
            © {new Date().getFullYear()}. All rights reserved |{" "}
            <span
              onClick={() => navigate("/privacy-policy")}
              style={{
                color: "#25d366",
                cursor: "pointer",
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Privacy Policy
            </span>
          </Typography>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default EmailForgotInput;
